import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import DownVector from "../../images/Svg/DownVector.svg";
import data from "./navbar.data";
import upVector from "../../images/Svg/upVector.svg";
import { getAnalytics, logEvent } from "firebase/analytics";
import { useContext, useEffect, useRef, useState } from "react";
import ArrowIcon from "../../images/Svg/ArrowIcon.svg";
import LoginModal from "../Modal/Login.Modal";
import GetDesoProfile from "../../Hooks/GetDesoProfile";
import NavbarDropdown from "./Navbar.dropdown";
import { ConfigContext } from "../../context/config";
import useIdentity from "../../utils/identity";
import Icon from "../../images/Svg/HumbergerIcon.svg";
import CloseIcon from "../../images/Svg/close.svg";
import UserBlueIcon from "../../images/Svg/dashboard/UserBlue.svg";
import UserIcon from "../../images/Svg/dashboard/userIcon.svg";
import RightArrow from "../../images/Svg/BackIconWhite.svg";
import { getWaterMarkApi } from "../../Network/network";
import { analytics } from "../../utils/firebase";
import { desoLoginSuccess, twitterSignOut } from "../../reducers/auth/action";
import { pushGaEvent } from "../../utils/ga_events";

// const analytics = getAnalytics();

const Navbar = () => {
  const dispatch = useDispatch();
  const { colorShow, deso } = useSelector((state) => state?.auth);
  const { navLinks } = data;
  const [showMenu, setShowMenu] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [dropdownShow, setDropdwonShow] = useState(false);
  const [dropdownShowMobile, setDropdwonShowMobile] = useState(false);
  const [status, setStatus] = useState(null);
  const { username } = GetDesoProfile();

  const { identityWindow } = useContext(ConfigContext);
  const { handleMessage, changeWatermarkIdentity } = useIdentity();
  useEffect(() => {
    window.addEventListener("message", (event) =>
      handleMessage(event, identityWindow)
    );
  }, [identityWindow]);

  useEffect(() => {
    if (deso?.user?.publicKeyAdded) fetchStatusData();
  }, [deso?.user?.publicKeyAdded]);

  const fetchStatusData = async () => {
    let bodyData = {
      public_key: deso?.user?.publicKeyAdded,
    };
    const res = await getWaterMarkApi(bodyData);
    if (res?.status == "success") {
      console.log(res?.status_watermark);
      setStatus(res?.status_watermark);
    }
  };

  const navbarShow = () => {
    if (window.scrollY > 400) {
      setShowMenu(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", navbarShow);
    return () => window.removeEventListener("scroll", navbarShow);
  }, []);

  useEffect(() => {
    if (modalShow) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modalShow]);

  const h = 1000;
  const w = 800;
  const y = window.outerHeight / 2 + window.screenY - h / 2;
  const x = window.outerWidth / 2 + window.screenX - w / 2;

  const desoLogin = async () => {
    // localStorage.clear();
    // dispatch(twitterSignOut());

    identityWindow.current = window.open(
      "https://identity.deso.org/log-in?accessLevelRequest=4",
      null,
      `toolbar=no, width=${w}, height=${h}, top=${y}, left=${x}`
    );
  };
  const pn = window.location.pathname;
  const handleDashboard = () => {
    logEvent(analytics, "START_SHIFTING_NOW_CLICKED");
    if (deso?.user) navigation("/dashboard");
    else setModalShow(true);

    setShowMenu(false);
  };
  const handleOpen = () => {
    setShowMenu(true);
  };
  const navigation = useNavigate();

  const handleChange = async () => {
    window.addEventListener("message", (event) =>
      handleMessage(event, identityWindow)
    );
    pushGaEvent(`CHANGE_WATERMARK_IDENTITY_CLICKED${!status}`);
    changeWatermarkIdentity(!status);

    setTimeout(() => {
      setStatus(!status);
    }, 2000);
  };

  return (
    <>
      <div
        className={`${
          colorShow ? " " : "bg-[#FFFFFF] border border-[#E1E1E1]"
        }`}
      >
        <div className=" container mx-auto  px-6 sm:px-6 lg:px-16 py-2">
          <div className="flex lg:inline items-center justify-between">
            <div className="flex lg:inline items-center">
              <div className="flex lg:hidden items-center">
                {pn != "/" && pn != "/home" && (
                  <button
                    onClick={() => navigation(-1)}
                    className="outline-none rounded ease-in-out duration-300 focus:ring-gray-600"
                  >
                    <img className="mx-[8px]" src={RightArrow} alt="" />
                  </button>
                )}
              </div>

              <div>
                <nav className="flex justify-between items-center m-auto">
                  <a href="/" className="flex items-center">
                    <img
                      className="h-[32px]"
                      src={"https://i.ibb.co/nkCpMcK/logo.png"}
                      alt="logo"
                    />
                  </a>

                  <ul className="hidden lg:flex items-center">
                    {navLinks.map((navLink, index) => (
                      <li key={index}>
                        <NavLink
                          onClick={() => {
                            logEvent(analytics, navLink?.eventName);
                            setShowMenu(false);
                          }}
                          to={`${navLink.cta}`}
                          className={({ isActive }) =>
                            isActive === true
                              ? " text-blue mx-4 underline underline-offset-1 "
                              : "mx-4 hover:text-[#5463FF]"
                          }
                        >
                          {navLink.title}
                        </NavLink>
                      </li>
                    ))}
                  </ul>

                  <ul className="hidden lg:flex justify-between items-center relative">
                    <li>
                      {deso?.user ? (
                        <>
                          <div
                            onClick={() => setDropdwonShow(!dropdownShow)}
                            className="flex_thing justify-between cursor-pointer w-[267px] px-[16px] py-[8px] hover:bg-[#F6F7FF]"
                          >
                            <div className="flex_thing">
                              <img
                                className="h-[30px] w-[30px]"
                                src={`https://web3setu.co.in/tweets/get-user-profile-image/${deso?.user?.publicKeyAdded}`}
                              />
                              <p className="ml-[8px]">
                                {username ? (
                                  username.length > 10 ? (
                                    <>@{username.slice(0, 10).concat("..")}</>
                                  ) : (
                                    <>@{username}</>
                                  )
                                ) : (
                                  deso?.user?.publicKeyAdded
                                    ?.slice(0, 10)
                                    .concat("..")
                                )}
                              </p>
                            </div>
                            <div>
                              <img
                                className="cursor-pointer"
                                src={dropdownShow ? upVector : DownVector}
                                alt=""
                              />
                            </div>
                          </div>
                          {dropdownShow && (
                            <NavbarDropdown
                              desoLogin={desoLogin}
                              mobile={false}
                              handleChange={handleChange}
                              status={status}
                              setStatus={setStatus}
                            />
                          )}
                        </>
                      ) : (
                        <button
                          className={` ${
                            colorShow ? "" : "bg-[#FFFFFF]"
                          } navbar-button p-6 text-black`}
                          onClick={handleDashboard}
                        >
                          Start Shifting Now
                          <span className="pl-2">
                            <img src={ArrowIcon} alt="" />
                          </span>
                        </button>
                      )}
                    </li>
                  </ul>
                </nav>
              </div>
            </div>

            <div className="flex lg:hidden items-center">
              {deso?.user && (
                <>
                  <img
                    onClick={() => setDropdwonShowMobile(!dropdownShowMobile)}
                    src={dropdownShowMobile ? UserBlueIcon : UserIcon}
                    alt=""
                    className="mr-[24px]"
                  />
                  {dropdownShowMobile && (
                    <NavbarDropdown
                      desoLogin={desoLogin}
                      mobile={true}
                      username={username}
                      status={status}
                      setStatus={setStatus}
                      handleChange={handleChange}
                    />
                  )}
                </>
              )}
              <div className="relative">
                {!showMenu && (
                  <button
                    aria-label="open menu"
                    onClick={handleOpen}
                    className="outline-none rounded ease-in-out duration-300 focus:ring-gray-600"
                  >
                    <img src={Icon} alt="menu" />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`${
          showMenu ? "flex ease-in-out duration-300 " : "hidden"
        } absolute w-[100%] top-0 left-0 z-30 pt-[24px] bg-white h-screen `}
      >
        <div className="container mx-auto px-8">
          <img
            onClick={() => setShowMenu(false)}
            className="mt-[16px] outline-none float-right ease-in-out duration-300 rounded "
            src={CloseIcon}
            alt=""
          />
          <div data-aos="fade-down" className="grid mt-[50px]">
            <ul className=" grid gap-5 text-lg">
              {navLinks.map((navLink, index) => (
                <li key={index}>
                  <NavLink
                    onClick={() => {
                      console.log(navLink?.eventName);
                      logEvent(analytics, navLink?.eventName);
                      setShowMenu(false);
                    }}
                    to={`${navLink.cta}`}
                    className={({ isActive }) =>
                      isActive === true
                        ? " text-blue mx-4 underline underline-offset-1 "
                        : "mx-4 hover:text-[#5463FF]"
                    }
                  >
                    {navLink.title}
                  </NavLink>
                </li>
              ))}

              {(pn == "/home" ||
                pn == "/" ||
                pn == "/about" ||
                pn == "/blogs" ||
                pn == "/blogs/0" ||
                pn == "/blogs/1" ||
                pn == "/blogs/2" ||
                pn == "/blogs/3" ||
                pn == "/faqs" ||
                pn == "/our_team" ||
                pn == "/blogs") && (
                <li>
                  <button
                    onClick={handleDashboard}
                    className="navbar-button text-[16px] p-6 text-black w-[215px] mx-auto"
                  >
                    Start Shifting Now
                    <span>
                      <img className="pl-[8px]" src={ArrowIcon} alt="" />
                    </span>
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      {modalShow ? (
        <LoginModal
          show={modalShow}
          setShow={setModalShow}
          desoLogin={desoLogin}
        />
      ) : null}
    </>
  );
};

export default Navbar;
